module.exports = __webpack_public_path__ + "static/media/SofiaProBold.28b75bc6.otf";